import {
  EMN_SET_CST_ICMS_SUCCESS,
  ENM_SET_CIDADES_SUCCESS,
  ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS,
  ENM_SET_METODOS_BUSCA_SUCCESS,
  ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS,
  ENM_SET_PORTAL_ESTADUAL_SUCCESS,
  ENM_SET_SITUACAO_MANIFESTO_SUCCESS,
  ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS,
  ENM_SET_TIPO_CONSULTA_SUCCESS,
  ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS,
  ENM_SET_TIPOS_ACESSO_SUCCESS,
  ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS,
  ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  tiposAcesso: [],
  tiposDocumentoFiscal: [],
  origensDocumentoFiscal: [],
  situacoesManifesto: [],
  situacaoXmlManifesto: [],
  descricaoCst: '',
  unidadesFederativas: [],
  tiposDocumentoConsulta: [],
  tiposConsulta: [],
  cidades: [],
  metodosBusca: [],
  estruturasDownload: [],
  portaisEstadual: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case ENM_SET_TIPOS_ACESSO_SUCCESS:
      return { ...state, tiposAcesso: payload };
    case ENM_SET_TIPOS_DOCUMENTO_FISCAL_SUCCESS:
      return { ...state, tiposDocumentoFiscal: payload };
    case ENM_SET_ORIGENS_DOCUMENTO_FISCAL_SUCCESS:
      return { ...state, origensDocumentoFiscal: payload };
    case EMN_SET_CST_ICMS_SUCCESS:
      return { ...state, descricaoCst: payload };
    case ENM_SET_SITUACAO_MANIFESTO_SUCCESS:
      return { ...state, situacoesManifesto: payload };
    case ENM_SET_SITUACAO_XML_MANIFESTO_SUCCESS:
      return { ...state, situacaoXmlManifesto: payload };
    case ENM_SET_UNIDADES_FEDERATIVAS_SUCCESS:
      return { ...state, unidadesFederativas: payload };
    case ENM_SET_TIPO_DOCUMENTO_CONSULTA_SUCCESS:
      return { ...state, tiposDocumentoConsulta: payload };
    case ENM_SET_TIPO_CONSULTA_SUCCESS:
      return { ...state, tiposConsulta: payload };
    case ENM_SET_CIDADES_SUCCESS:
      return { ...state, cidades: payload };
    case ENM_SET_METODOS_BUSCA_SUCCESS:
      return { ...state, metodosBusca: payload };
    case ENM_SET_ESTRUTURA_DOWNLOAD_SUCCESS:
      return { ...state, estruturasDownload: payload };
    case ENM_SET_PORTAL_ESTADUAL_SUCCESS:
      return { ...state, portaisEstadual: payload };
    default:
      return state;
  }
};
